<mat-grid-list id="matAlertModalHeading" cols="4" rowHeight="3rem">
  <mat-grid-tile
    data-test-id="lblmatAlertModalTitle"
    aria-labelledby="lblmatAlertModalTitle"
    colspan="3"
    class="dialog-title"
  >
    <h5 data-test-id="lblDialogHeader">
      {{ data.heading | translate }}
    </h5>
  </mat-grid-tile>
</mat-grid-list>
<mat-divider class="divider-spacer"></mat-divider>
<mat-dialog-content
  aria-labelledby="matAlertModalHeading"
  data-test-id="contmatAlertModal"
  class="cust-mat-dialog-sm"
>
  <p
    [innerHtml]="data.message | translate: { url: webitUrl() }"
    data-test-id="lblDialogContent"
  ></p>
  <mat-divider class="divider-spacer"></mat-divider>
  <mat-grid-list cols="1" rowHeight="4.75rem">
    <mat-grid-tile>
      <button
        mat-raised-button
        cg-mat-btn-type="primary"
        class="btn-large"
        (click)="close()"
        data-test-id="btnDialogSubmit"
      >
        {{ data.buttonText | translate }}
      </button>
    </mat-grid-tile>
  </mat-grid-list>
</mat-dialog-content>
